import { RuleActionType } from '@jupiterone/jupiter-types/rule';
import React from 'react';
import {
  EmailActionData,
  JiraActionData,
  RuleActionData,
  SNSActionData,
  SQSActionData,
  ServiceNowActionData,
} from 'jupiter-web-alerts/src/types';
import JiraRuleConfig from './JiraRuleConfig';
import SendEmailRuleConfig from './SendEmailRuleConfig';
import SimpleRuleConfig from './SimpleRuleConfig';
import SlackRuleConfig from './SlackRuleConfig';
import SNSRuleConfig from './SNSRuleConfig';
import SQSRuleConfig from './SQSRuleConfig';
import ServiceNowRuleConfig from './ServiceNowRuleConfig';

interface Props {
  actionType: RuleActionType;
  onUpdate: (newValue: RuleActionData) => void;
  disabled?: boolean;
  initialActionData?: RuleActionData;
  templateData?: Record<string, string>;
}

const RuleActionConfig = ({
  actionType,
  onUpdate,
  disabled,
  initialActionData,
  templateData,
}: Props) => {
  const DEFAULT_WEBHOOK_CONFIG = {
    type: RuleActionType.WEBHOOK,
    configTitle: 'Webhook Config',
    onUpdate,
    fields: {
      endpoint: { label: 'endpoint' },
      method: {
        label: 'method',
        initialValue: 'POST',
        helpText:
          'HTTP method to use when making the request Allowed values: POST, PUT, GET, HEAD, PATCH, DELETE.',
      },
      body: {
        label: 'body',
        initialValue: {},
        helpText:
          'Body data to include in the request. Can only be used with POST, PUT, and PATCH.',
        type: 'json' as const,
      },
      headers: {
        label: 'headers',
        helpText: '	HTTP headers to include in the request.',
        initialValue: {},
        type: 'json' as const,
      },
    },
  };

  switch (actionType) {
    case RuleActionType.SEND_EMAIL:
      return (
        <SendEmailRuleConfig
          onUpdate={onUpdate}
          disabled={disabled}
          initialActionData={initialActionData as EmailActionData}
          templateData={templateData}
        />
      );
    case RuleActionType.CREATE_JIRA_TICKET:
      return (
        <JiraRuleConfig
          onUpdate={onUpdate}
          disabled={disabled}
          initialActionData={initialActionData as JiraActionData}
        />
      );
    case RuleActionType.CREATE_SERVICE_NOW_INCIDENT:
      return (
        <ServiceNowRuleConfig
          onUpdate={onUpdate}
          disabled={disabled}
          initialActionData={initialActionData as ServiceNowActionData}
        />
      );
    case RuleActionType.SEND_SLACK_MESSAGE:
      return (
        <SlackRuleConfig
          onUpdate={onUpdate}
          disabled={disabled}
          initialActionData={initialActionData}
          templateData={templateData}
        />
      );
    case RuleActionType.WEBHOOK:
      return (
        <SimpleRuleConfig
          {...DEFAULT_WEBHOOK_CONFIG}
          disabled={disabled}
          initialActionData={initialActionData}
        />
      );
    case RuleActionType.SEND_SQS_MESSAGE:
      return (
        <SQSRuleConfig
          onUpdate={onUpdate}
          disabled={disabled}
          initialActionData={initialActionData as SQSActionData}
        />
      );
    case RuleActionType.PUBLISH_SNS_MESSAGE:
      return (
        <SNSRuleConfig
          onUpdate={onUpdate}
          disabled={disabled}
          initialActionData={initialActionData as SNSActionData}
        />
      );
    default:
      return <div />;
  }
};

export default RuleActionConfig;
